import { resourceConstants } from "./constants/resourceConstant";

const resourceGetByFilter = (data: any) => {
	return {
		type: resourceConstants.Resource_GetByFilter_Request,
		input: data
	};
};

const resourceGetActiveList = (data: any) => {
	return {
		type: resourceConstants.Resource_GetActive_Request,
		input: data
	};
};

const resourceSave = (id: any, resourceInput: any) => {
	return {
		type: resourceConstants.ResourceSaveRequest,
		input: { resourceInput: resourceInput, id: id }
	};
};

const resourceGetDetail = (id: any) => {
	return {
		type: resourceConstants.ResourceDetailRequest,
		input: id
	};
};

const resourceDelete = (id: any) => {
	return {
		type: resourceConstants.ResourceDeleteRequest,
		input: id
	};
};

const resourceUpdateStatus = (id: any, isActive: boolean) => {
	return {
		type: resourceConstants.ResourceStatusUpdateRequest,
		input: { id: id, isActive: isActive }
	};
};

export const resourceAction = {
	resourceGetByFilter,
	resourceGetActiveList,
	resourceSave,
	resourceGetDetail,
	resourceDelete,
	resourceUpdateStatus
};
